import { SearchTerm } from './SearchTerm';

const ReportTypeSearch: SearchTerm[] = [
    {
        heading: "Type",
        accessor: "type",
        searchOnName: "trnName",
        translationKey: "type"
    }
];

export default ReportTypeSearch;